<template>
    <div :style="panelStyle">
        <!-- Trader 右侧面板 -->
        <transition name="drawer-slide">
            <div v-if="isOpen && customerType === 'trader'" class="trader-side-panel">
                <div class="trader-content">
                    <h2 class="font-apercu-bold">Trade Account</h2>
                    <p style="padding-top: 52rem;">Exclusive access for interior designers, architects, and design professionals.</p>
                    <p>Stay ahead with early previews of new collections, materials, finishes.</p>
                    <p>Be the first to know.</p>
                    <a href="#" class="register-link">Register Now</a>
                </div>
            </div>
        </transition>

        <!-- 遮罩层 -->
        <div v-if="isOpen" class="login-overlay" @click="closeLogin"></div>

        <!-- 登录面板 -->
        <div ref="loginPanel" class="login-panel" :class="{ 'login-open': isOpen }">
            <!-- 顶部导航 -->
            <nav class="login-top-nav font-apercu-regular">
                <a href="#" class="nav-link inactive" @click.prevent="switchToMenu">
                    Menu
                </a>
                <span class="nav-link active font-apercu-regular">
                    Login
                </span>
            </nav>

            <div class="login-content">
                <div class="customer-type-selector">
                    <span class="type-option" :class="{ active: customerType === 'private' }"
                        @click="customerType = 'private'">
                        Private Customer
                    </span>
                    <span class="separator">|</span>
                    <span class="type-option" :class="{ active: customerType === 'trader' }"
                        @click="customerType = 'trader'">
                        Trade
                    </span>
                </div>

                <!-- 登录表单 -->
                <form v-if="!isRegister && !isForgot" class="login-form" @submit.prevent="handleSubmit">
                    <div class="form-group">
                        <label for="email" :class="{ 'faded': form.email }">Email</label>
                        <input type="email" id="email" v-model="form.email" required />
                    </div>

                    <div class="form-group">
                        <label for="password" :class="{ 'faded': form.password }">Password</label>
                        <input type="password" id="password" v-model="form.password" required />
                    </div>

                    <div class="form-actions">
                        <a href="#" class="forgot-password" @click.prevent="switchToForgotPassword">Forget Your
                            Password?</a>
                        <button type="submit" class="submit-btn">[Submit]</button>
                    </div>
                </form>

                <!-- 忘记密码表单 -->
                <form v-else-if="isForgot" class="login-form" @submit.prevent="handleForgotPassword">
                   <div class="form-group" style="display: flex; align-items: center;">
                       <label for="forgot-email" :class="{ 'faded': forgotForm.email }">Email</label>
                       <input type="email" id="forgot-email" v-model="forgotForm.email" required style="flex: 1;" />
                       <button type="button" class="send-code-btn" @click="sendVerificationCode" :disabled="codeSending">
                           {{ codeSending ? 'Sending...' : '[Get Code]' }}
                       </button>
                   </div>
					<div class="form-group">
					    <label for="forgot-phone" :class="{ 'faded': forgotForm.code }">Verification Code</label>
					    <input type="text" id="forgot-phone" v-model="forgotForm.code" />
					</div>
					<div class="form-group">
                        <label for="forgot-password" :class="{ 'faded': forgotForm.password }">New Password</label>
                        <input type="password" id="forgot-password" v-model="forgotForm.password" required />
                    </div>
                    <div class="form-actions">
                        <a href="#" class="forgot-password"></a>
                        <button type="submit" class="submit-btn">[Submit]</button>
                    </div>
                </form>

                <!-- 注册表单 -->
                <form v-else class="login-form" @submit.prevent="handleRegister">
                    <div class="form-group">
                        <label for="register-email" :class="{ 'faded': registerForm.Email }">Email</label>
                        <input type="email" id="register-email" v-model="registerForm.Email" required />
                    </div>

                    <div class="form-group">
                        <label for="register-password" :class="{ 'faded': registerForm.Password }">Password</label>
                        <input type="password" id="register-password" v-model="registerForm.Password" required />
                    </div>

                    <div class="form-group">
                        <label for="register-first-name" :class="{ 'faded': registerForm.FirstName }">First Name</label>
                        <input type="text" id="register-first-name" v-model="registerForm.FirstName" required />
                    </div>

                    <div class="form-group">
                        <label for="register-last-name" :class="{ 'faded': registerForm.LastName }">Last Name</label>
                        <input type="text" id="register-last-name" v-model="registerForm.LastName" required />
                    </div>

                    <!-- 公司名称字段：仅 trader 时显示 -->
                    <div class="form-group" v-if="customerType === 'trader'">
                        <label for="register-company-name" :class="{ 'faded': registerForm.CompanyName }">Company
                            Name</label>
                        <input type="text" id="register-company-name" v-model="registerForm.CompanyName" />
                    </div>

                    <!-- 职位字段：仅 trader 时显示 -->
                    <div class="form-group" v-if="customerType === 'trader'">
                        <label for="register-position" :class="{ 'faded': registerForm.Position }">Position</label>
                        <input type="text" id="register-position" v-model="registerForm.Position" />
                    </div>

                    <div class="form-group">
                        <label for="register-phone" :class="{ 'faded': registerForm.Phone }">Phone</label>
                        <input type="text" id="register-phone" v-model="registerForm.Phone" />
                    </div>
					
					 <div class="form-group">
					                        <label for="register-country" :class="{ 'faded': registerForm.Country }">Country</label>
					                        <input type="text" id="register-country" v-model="registerForm.Country" />
					                    </div>

                    <div class="form-actions">
                        <a href="#" class="forgot-password"></a>
                        <button type="submit" class="submit-btn" style="font-family: 'Apercu-Medium', sans-serif;">[Submit]</button>
                    </div>
                </form>

                <div class="create-account">
                    <a v-if="!isRegister && !isForgot" href="#" class="create-link" @click.prevent="switchToRegister">
                        {{ customerType === 'private' ? 'Create an Account' : 'Create Trade Account' }}
                    </a>
                    <a v-else href="#" class="create-link" @click.prevent="switchToLogin">
                        Back to Login
                    </a>
                </div>
            </div>

            <!-- 底部链接 -->
            <div class="login-bottom-links font-bespoke">
                <a href="#" class="bottom-link" @click.prevent="openEmailPopup">Subscribe</a>
            </div>
        </div>
    </div>
</template>

<script>
import { loginUser, registerUser, forgotpassword, changepassword } from '@/api/user'  
import { setToken, setUser } from '@/config/auth'
import { showMessage } from '@/config/message'

export default {
    name: 'Login',
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        initialCustomerType: {
            type: String,
            default: 'private'
        },
		initialIsRegister: {
		    type: Boolean,
		    default: false
		}
    },
    data() {
        return {
            codeSending: false, // 防止重复点击
            customerType: 'private',
            isRegister: false,
            isForgot: false,
            loginPanelWidth: 0,
            form: {
                email: '',
                password: ''
            },
            forgotForm: {
                email: '',
                password: '',
                code: ''
            },
            registerForm: {
                Email: '',
                Password: '',
                FirstName: '',
                LastName: '',
                UserType: 'Private',
                CompanyName: '',
                Position: '',
                Phone: '',
				Country: '',   
                IsSubscribed: false
            }
        }
    },
    watch: {
        isOpen(val) {
			console.log('initialCustomerType:', this.initialCustomerType);
			console.log('initialCustomerType:', this.initialCustomerType==666?true:false);
            if (val) {
                this.customerType = this.initialCustomerType==666?'private':this.initialCustomerType
                this.isRegister = this.initialIsRegister
                this.isForgot = false
                this.form.email = ''
                this.form.password = ''
                this.forgotForm.email = ''
                this.forgotForm.password = ''
                this.forgotForm.code = ''
                this.registerForm = {
                    Email: '',
                    Password: '',
                    FirstName: '',
                    LastName: '',
                    UserType: this.initialCustomerType === 'private' ? 'Private' : 'Trader',
                    CompanyName: '',
                    Position: '',
                    Phone: '',
					Country: '',     
                    IsSubscribed: false
                }
            }
            this.$nextTick(this.updatePanelWidth)
        },
        customerType(newValue) {
            if (!this.isRegister) return
            this.registerForm.UserType = newValue === 'private' ? 'Private' : 'Trader'
            if (newValue === 'private') {
                this.registerForm.CompanyName = ''
                this.registerForm.Position = ''
            }
        }
    },
    computed: {
        panelStyle() {
            return {
                '--login-panel-width': this.loginPanelWidth ? `${this.loginPanelWidth}px` : '32.14%'
            }
        }
    },
    mounted() {
        this.updatePanelWidth()
        window.addEventListener('resize', this.updatePanelWidth)
    },
    methods: {
        updatePanelWidth() {
            const panel = this.$refs.loginPanel
            if (!panel) return
            this.loginPanelWidth = panel.offsetWidth
        },
        closeLogin() {
            if (this.customerType === 'trader') {
                this.customerType = 'private'
                setTimeout(() => {
                    this.$emit('close')
                }, 800)
            } else {
                this.$emit('close')
            }
        },
        switchToMenu() {
            this.$emit('switch-to-menu')
        },
        switchToRegister() {
            this.isRegister = true
            this.isForgot = false
            this.registerForm.UserType = this.customerType === 'private' ? 'Private' : 'Trader'
        },
        switchToLogin() {
            this.isRegister = false
            this.isForgot = false
        },
        switchToForgotPassword() {
            this.isForgot = true
            this.isRegister = false
        },
        validateRegisterForm() {
            const { Email, Password, FirstName, LastName, CompanyName, Position } = this.registerForm
            if (!Email) {
                showMessage('Email is required', 'error')
                return false
            }
            if (!Password) {
                showMessage('Password is required', 'error')
                return false
            }
            if (!FirstName) {
                showMessage('First name is required', 'error')
                return false
            }
            if (!LastName) {
                showMessage('Last name is required', 'error')
                return false
            }
            // if (!Phone) {
            //     showMessage('Phone number is required', 'error')
            //     return false
            // }
            if (this.customerType === 'trader') {
                if (!CompanyName) {
                    showMessage('Company name is required for trader', 'error')
                    return false
                }
                if (!Position) {
                    showMessage('Position is required for trader', 'error')
                    return false
                }
            }
            return true
        },
        async handleSubmit() {
            try {
                const payload = {
                    Email: this.form.email,
                    Password: this.form.password
                }
                const result = await loginUser(payload)
                let token = ''
                let userInfo = null
                if (typeof result === 'string') {
                    token = result
                } else if (result && typeof result === 'object') {
                    token = result.token || null
                    userInfo = result.result || null
                }
                if (token) {
                    setToken(token)
                }
                if (userInfo) {
                    setUser(userInfo)
                }
                if (result.retCode === 1) {
                    console.log('Login success:', result)
                    // showMessage(result.retMsg || 'Login success', 'success')
                    this.closeLogin()
					
					this.$root.$emit('login-success')   // 触发全局事件
					
					// 新增：通知父组件打开用户信息侧栏
					 this.$root.$emit('open-user-panel')  // 自定义事件，父组件监听
                } else {
                    showMessage(result.retMsg || 'Login failed', 'error')
                }
            } catch (error) {
                console.error('Login failed:', error)
            }
        },
        async handleRegister() {
            if (!this.validateRegisterForm()) {
                return
            }
            try {
                const result = await registerUser(this.registerForm)
                console.log('Register success:', result)
                if (result && result.retCode == 1) {
                    showMessage(result.retMsg || 'Register success', 'success')
                    if (result.token) {
                        setToken(result.token)
                    }
                    if (result.result) {
                        let userInfo = result.result
                        userInfo.totalCount = result.totalCount
                        setUser(userInfo)
                    }
                    this.isRegister = false
                    this.closeLogin()
					
					this.$root.$emit('login-success')   // 触发全局事件
                } else {
                    showMessage(result.retMsg || 'Registration failed', 'error')
                }
            } catch (error) {
                console.error('Register failed:', error)
            }
        },
        // 发送验证码
        async sendVerificationCode() {
            const email = this.forgotForm.email;
            if (!email) {
                showMessage('Please enter your email', 'error');
                return;
            }
            // 简单邮箱格式正则（可根据需要调整）
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                showMessage('Please enter a valid email address', 'error');
                return;
            }
            this.codeSending = true;
            try {
                // 调用 forgotpassword API，传入邮箱字符串
                const result = await forgotpassword(email);
                showMessage(result.retMsg || 'Verification code sent to your email', 'success');
            } catch (error) {
                showMessage(error.message || 'Failed to send code', 'error');
            } finally {
                this.codeSending = false;
            }
        },
        // 提交新密码和验证码
        async handleForgotPassword() {
			debugger
            const { email, password, code } = this.forgotForm
            if (!email || !password || !code) {
                showMessage('Please fill in all fields', 'error')
                return
            }
            try {
                // 调用 changepassword API，传入对象
                const result = await changepassword({
                    Email: email,
                    NewPassword: password,
                    Code: code
                })
                showMessage(result.retMsg || 'Password reset successfully', 'success')
                this.switchToLogin() // 重置成功后返回登录
            } catch (error) {
                showMessage(error.message || 'Reset failed', 'error')
            }
        },
        openEmailPopup() {
            this.$emit('close')
            this.$emit('open-email-popup')
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updatePanelWidth)
    }
}
</script>

<style scoped>
/* 样式保持不变 */
.login-overlay {
    position: fixed;
    top: 0;
    left: 0%;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.2);   /* 20% 白色透明 */
    backdrop-filter: blur(20px);            /* 模糊背景 */
    -webkit-backdrop-filter: blur(20px);    /* Safari 兼容 */
    z-index: 998;
    animation: fadeIn 0.3s ease;
    pointer-events: auto;
}

@media (max-width: 1024px) {
    .login-overlay {
        left: 40%;
    }
}

@media (max-width: 768px) {
    .login-overlay {
        left: 0;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.login-panel {
    position: fixed;
    top: 0;
    left: 0;
    right: auto;
    width: 32.14%;
    max-width: 486rem;
    height: 100vh;
    background: #ffffff;
    z-index: 11005;
    transform: translateX(-100%);
    transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
    display: flex;
    flex-direction: column;
    padding: 40rem;
	padding-top: 23rem;
    overflow-y: auto;
    border-right: 2rem solid #000;
}

.login-panel.login-open {
    transform: translateX(0);
}

.login-top-nav {
    display: flex;
    gap: 18rem;
    margin-bottom: 60rem;
}

.nav-link {
    font-size: 16rem;
    text-decoration: none;
    color: #000;
    cursor: pointer;
}

.nav-link.inactive {
    color: #999;
}

.nav-link.active {
    color: #000;
}

.login-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 40rem;
    font-family: 'Apercu-Medium', serif;
}

.customer-type-selector {
    display: flex;
    align-items: center;
    gap: 10rem;
    font-size: 16rem;
    margin: 0 auto;
    margin-bottom: 20rem;
}

.type-option {
    cursor: pointer;
    color: #999;
    display: flex;
    align-items: center;
    font-size: 20rem;
    gap: 5rem;
}

.type-option.active {
    color: #000;
    font-weight: 500;
}

.separator {
    color: #000;
    margin: 0 5rem;
}

.red-arrow {
    color: red;
    font-size: 12rem;
}

.login-form {
    display: flex;
    flex-direction: column;
}

.form-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    border-bottom: 2rem solid #000;
    height: 45rem;
    line-height: 45rem;
}

.form-group label {
    font-size: 16rem;
    font-weight: 500;
    color: #000;
    transition: opacity 0.8s ease;
    white-space: nowrap;
}

.form-group label.faded {
    display: none;
}

.form-group input {
    border: none;
    font-family: inherit;
    font-size: 18rem;
    outline: none;
    background: transparent;
    width: 100%;
}

.form-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 14rem;
}

.forgot-password {
    font-size: 16rem;
    color: #000;
    text-decoration: none;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.submit-btn {
    background: none;
    border: none;
    font-family: inherit;
    font-size: 16rem;
    font-weight: 500;
    cursor: pointer;
    padding: 0;
	font-family: 'Apercu-Medium', sans-serif;
}

.create-account {
    margin: 0 auto;
    margin-top: 98rem;
}

.create-link {
    font-size: 16rem;
    color: #000;
    text-decoration: none;
    font-weight: 500;
    display: flex;
    align-items: center;
}

.create-link .red-arrow {
    margin-right: 5rem;
}

.login-bottom-links {
    margin-top: auto;
    padding-top: 40rem;
}

.bottom-link {
    font-size: 16rem;
    font-weight: 400;
    color: #000;
    text-decoration: none;
	font-family: 'Apercu-Medium', serif;
}

.trader-side-panel {
    position: fixed;
    top: 0;
    left: var(--login-panel-width, 32.14%);
    width: 38.22%;
    max-width: 578rem;
    bottom: 0;
    background-color: transparent;
    background-image: url('../assets/login/trader.png');
    background-size: cover;
    background-position: center;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
    border-right: 2px solid #000000;
}

.trader-side-panel::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
}

.trader-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30rem;
    max-width: 600rem;
    padding: 99rem;
    position: relative;
    z-index: 1;
    font-family: 'Apercu-Medium', serif;
}

.trader-content h2 {
    font-weight: 700;
    font-size: 24rem;
    line-height: 100%;
    text-align: center;
}

.trader-content p {
    font-weight: 500;
    font-size: 20rem;
    line-height: 100%;
    text-align: center;
}

.red-arrow-down {
    color: red;
    font-size: 24rem;
    margin-bottom: 20rem;
    font-weight: bold;
}

.register-link {
    color: #fff;
    font-size: 20rem;
    text-decoration: none;
    margin-top: 30rem;
    font-weight: 500;
}

.drawer-slide-enter-active,
.drawer-slide-leave-active {
    transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
}

.drawer-slide-enter,
.drawer-slide-leave-to {
    transform: translateX(-100%);
}



.send-code-btn {
    background: none;
    border: none;
    font-family: inherit;
    font-size: 16rem;
    cursor: pointer;
    padding: 0 0 0 10rem;
    white-space: nowrap;
    color: #000;
    text-decoration: underline;
}
.send-code-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}


@media (max-width: 1024px) {
    .login-panel {
        width: 40%;
    }
    .trader-side-panel {
        left: 40%;
        width: 40%;
    }
}

@media (max-width: 768px) {
    .login-panel {
        width: 100%;
    }
    .login-overlay {
        left: 0;
    }
    .trader-side-panel {
        display: none;
    }
}
</style>